module.exports = __webpack_public_path__ + "static/media/nurturing.400b5cba.svg";